import createReducer from '../../utils/createReducer';
import {
  FETCH_BANK_ACCOUNTS_SUCCESS,
  FETCH_BANK_ACCOUNTS_ERROR,
  CONNECT_ACH_BANK_ACCOUNTS_SUCCESS,
  CONNECT_ACH_BANK_ACCOUNTS_ERROR,
} from '../../actions/bankAccount/bankAccountActionConstants';

const initialState = {
  bankAccounts: [],
  plaidBankAccountUid: '',
  error: '',
};

export default createReducer(
  {
    [FETCH_BANK_ACCOUNTS_SUCCESS]: getBankAccountSuccess,
    [FETCH_BANK_ACCOUNTS_ERROR]: getBankAccountError,
    [CONNECT_ACH_BANK_ACCOUNTS_SUCCESS]: connectPlaidBankAccountSuccess,
    [CONNECT_ACH_BANK_ACCOUNTS_ERROR]: connectPlaidBankAccountError,
  },
  initialState,
);

function getBankAccountSuccess(state, action) {
  return {
    ...state,
    bankAccounts: action.payload,
    error: '',
  };
}

function getBankAccountError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function connectPlaidBankAccountSuccess(state, action) {
  return {
    ...state,
    plaidBankAccountUid: action.payload,
    error: '',
  };
}

function connectPlaidBankAccountError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}
